import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';
var Svg = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0Zm5.602 6.728a.722.722 0 0 0-1.051.064l-5.817 6.87-3.375-2.835a.725.725 0 0 0-1.046.12.77.77 0 0 0 .113 1.05l3.929 3.3a.724.724 0 0 0 1.023-.089l6.285-7.424a.77.77 0 0 0-.06-1.056h-.001Z",
    fill: "currentColor"
  }));
});
var CheckCircled = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});
export { CheckCircled };